export const isValidNumber = (value) => typeof value === 'number' && !isNaN(value);
